import Plyr from "plyr";

class VideoPlayer{
    constructor() {
        this.videoEl = document.getElementById('homeHeroVideo');
        if (!this.videoEl) return;
    
        this.container = this.videoEl.closest('.video--container');
        this.section   = this.videoEl.closest('.homepage--hero-section');

        // ── Forza muted sull'elemento nativo PRIMA di inizializzare Plyr
        this.videoEl.muted = true;
        this.videoEl.setAttribute('muted', '');
        this.videoEl.defaultMuted = true;
        this.player = null;
    
        this.init();
    }
    
    init() {
        this.player = new Plyr(this.videoEl, {
            controls: [],          // nessun controllo nativo — hero è decorativo
            autoplay: true,
            muted: true,
            loop: { active: true },
            clickToPlay: false,
            disableContextMenu: true,
            hideControls: true,
            playsinline: true,
            storage: { enabled: false },
        });
    
        this.player.on('ready', () => {
            this.player.muted = true;
            this.player.elements.original.muted = true;
            this.player.elements.original.defaultMuted = true;
            //this.play();
            this.tryPlay();
        });
    
        this.player.on('playing', () => {
            this.container?.classList.add('is--ready');
            this.section?.classList.add('video--playing');
        });
    
        // Se vuoi esporre un toggle mute (es. un bottone custom nel template)
        const muteBtn = document.querySelector('[data-hero-mute]');
        if (muteBtn) {
        muteBtn.addEventListener('click', () => this.toggleMute(muteBtn));
        }
    }

    tryPlay() {
        // Tentativo diretto
        const promise = this.player.elements.original.play();

        if (promise !== undefined) {
            promise
                .then(() => {
                    // Partito — sync con Plyr
                    this.player.play();
                })
                .catch(() => {
                    // Safari ha bloccato — usa Intersection Observer
                    // per riprovare appena il video è visibile nel viewport
                    this.observeVisibility();
                });
        }
    }

    observeVisibility() {
        if (!('IntersectionObserver' in window)) {
            // Fallback per browser vecchissimi
            this.container?.classList.add('is--ready');
            return;
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    // Riprova il play quando l'elemento entra nel viewport
                    this.player.elements.original.play()
                        .then(() => {
                            this.player.play();
                            observer.disconnect();
                        })
                        .catch(() => {
                            // Safari mobile con policy più restrittiva
                            // mostra almeno il poster
                            this.container?.classList.add('is--ready');
                            observer.disconnect();
                        });
                }
            });
        }, { threshold: 0.1 });

        observer.observe(this.videoEl);
    }
    
    toggleMute(btn) {
        this.player.muted = !this.player.muted;
        btn.classList.toggle('is--muted', this.player.muted);
        btn.setAttribute('aria-label', this.player.muted ? 'Attiva audio' : 'Disattiva audio');
    }
}

export { VideoPlayer }